import React, { Component } from 'react'
import { connect } from 'react-redux'
import MainHeaderNav from '../main-header-nav'

import { 
	openModal, 
	changeTitle, 
	logoutUser,
	togglePreference,
	getStakeholdersAndPurposes
} from 'state/actions'

import SectionControls from 'components/controls/section-controls'
import Onboarder from 'components/onboarder/onboarder'

import MobileFooterButtons from 'components/mobile/footer-buttons'

import { 
	getCurrentAccount,
	getCurrentUser,
	isCurrentUserAdmin,
	getUserRoles,
	isPremium
} from 'state/selectors'

import TeamRoute from './team-route'

import { 
	Switch, 
	Route, 
	Redirect, 
	withRouter 
} from 'react-router'

import { 
	doSort,
	isMobile
} from 'utils'

class Team extends Component {
	state = {
		searchTerm: '',
		toggleState: 0,
		currentTab: 0,
		shouldBlockTransition: false
	}

	toggleOptions = [
		{
			name: 'Grid view'
		},
		{
			name: 'List view'
		}
	]

	UNSAFE_componentWillMount(){
		const {
			changeTitle,
			getStakeholdersAndPurposes,
			userData,
			currentAccount
		} = this.props

		changeTitle('Team')

		if(currentAccount && currentAccount.has_meetings){
			getStakeholdersAndPurposes(currentAccount.id)
		}

		if(!currentAccount || !userData){
			return 
		}

		this.setState({
			toggleState: userData.users_view_toggled ? 1 : 0
		})
	}

	onSearchTermChange = searchTerm => {
		this.setState({
			searchTerm
		})
	}

	addUser = _ => {
		const {
			openModal
		} = this.props

		openModal('invite', 'invite')
	}

	addGuest = _ => {
		const {
			openModal
		} = this.props

		openModal('invite', 'invite', {
			type: 'guest'
		})
	}

	addStakeholder = _ => {
		const {
			openModal
		} = this.props

		openModal('add','stakeholder')
	}

	addTeam = _ => {
		const {
			openModal,
			isPremium
		} = this.props

		if(isPremium){
			openModal('create', 'team')
		}else{
			openModal('pricing','pricing', {
				feature: 'teams'
			})
		}
	}

	editTeam = team => {
		const {
			openModal
		} = this.props

		openModal('edit', 'team', team)
	}

	deleteTeam = team => {
		const {
			openModal
		} = this.props

		openModal('delete', 'team', team)
	}

	toggleView = _ => {
		this.setState({
			toggleState: !this.state.toggleState,
			shouldBlockTransition: true
		}, _ => {
			window.requestAnimationFrame(_ => {
				this.setState({
					shouldBlockTransition: false
				})
			})
		})

		this.props.togglePreference(this.props.userData, 'users_view')
	}

	UNSAFE_componentWillUpdate = nextProps => {
		if(!nextProps.accountData){
			this.props.logoutUser()
		}
	}

	render() {
		const {
			accountData,
			isGuest,
			allUsers,
			allInvitations,
			allStakeholders,
			match,
			location,
			amAdmin,
			allTeams,
			roles,
			isPremium,
			userData,
		} = this.props
		
		const {
			toggleState,
			searchTerm,
			shouldBlockTransition
		} = this.state

		if(!accountData){
			return null
		}

		let navtabs = [{
			name: 'Staff',
			path: 'staff'
		}]

		const canEditTeam = (roles.admin || roles.pm)

		if(!isGuest){
			navtabs.push({
				name: 'Guests',
				path: 'guests'
			})

			if(!isMobile()){
				navtabs.push({
					name: 'Teams',
					path: 'teams',
					onboarder: (
						<Onboarder type='OPENED_TEAMS' direction="top-left"/>
					)
				})
			}
		}

		if(accountData && accountData.has_meetings){
			navtabs.push({
				name: 'Stakeholders',
				path: 'stakeholders'
			})
		}

		let userList = []
		let inviteList = []
		let teamList = []

		const buttonProps = []

		let tabName = (location.pathname+'/').replace(match.url, '').replace(/\//g,'')

		switch(tabName){
			case 'teams':
				buttonProps.push({
					size: 'big',
					level: 'high',
					label: 'Create team',
					icon: 'fe-users',
					callback: this.addTeam,
					disabled: !canEditTeam,
					tooltip: !canEditTeam ? `Only admins can create teams` : null
				})

				if(isPremium){
					accountData.teams && accountData.teams.forEach(teamId => {
						const team = allTeams[teamId]

						if(!team){
							return
						}

						let shouldPushTeam = roles.admin || roles.pm

						if(!shouldPushTeam){
							if(team.userIds.indexOf(userData.id) !== -1){
								shouldPushTeam = true
							}
						}

						if(shouldPushTeam){
							teamList.push(team)
						}
					})

					teamList = doSort(teamList, 'alpha', 'name')
				}

				break
			case 'staff':
				accountData.users.forEach(userId => {
					const userObject = allUsers[userId]

					if(userObject && accountData.guestIds.indexOf(userId) === -1){
						userList.push(userObject)
					}
				})

				accountData.invitations.forEach(invitationId => {
					const invitationObject = allInvitations[invitationId]

					if(!invitationObject || invitationObject.completed || invitationObject.is_invalidated){
						return
					}

					if(!userList.find(user => {
						return user.email === invitationObject.recipient_email
					})){
						if(!invitationObject.is_guest){
							inviteList.push(invitationObject)
						}
					}
				})

				buttonProps.push({
					size: 'big',
					level: 'high',
					label: 'Invite staff',
					icon: 'fe-user-plus',
					callback: this.addUser,
					disabled: !canEditTeam,
					tooltip: !canEditTeam ? `Only admins can invite` : null
				})
				break
			case 'guests':
				accountData.guestIds.forEach(userId => {
					const userObject = allUsers[userId]

					if(userObject){				
						userList.push(userObject)
					}
				})

				accountData.invitations.forEach(invitationId => {
					const invitationObject = allInvitations[invitationId]

					if(!invitationObject || invitationObject.completed || invitationObject.is_invalidated){
						return
					}

					if(!userList.find(user => {
						return user.email === invitationObject.recipient_email
					})){
						// If it can't find a matching user AND it is a guest
						if(invitationObject.is_guest){
							inviteList.push(invitationObject)
						}
					}
				})

				buttonProps.push({
					size: 'big',
					level: 'high',
					label: 'Invite guests',
					icon: 'fe-user-plus',
					callback: this.addGuest,
					disabled: !canEditTeam,
					tooltip: !canEditTeam ? `Only admins can invite` : null
				})
				break
			case 'stakeholders':
				buttonProps.push({
					size: 'big',
					level: 'high',
					label: 'Add stakeholder',
					icon: 'fe-user-plus',
					callback: this.addStakeholder,
					disabled: !canEditTeam,
					tooltip: !canEditTeam ? `Only admins can add stakeholders` : null
				})

				accountData.stakeholders && accountData.stakeholders.map(stakeholderId => {
					const stakeholder = allStakeholders[stakeholderId]

					if(stakeholder.is_private && (!roles.admin && !roles.pm)){
						return
					}

					if(stakeholder){
						userList.push(stakeholder)
					}
				})
				
				break
		}

		userList.sort((a,b) => {
			if(a.first_name < b.first_name) return -1
			if(a.first_name > b.first_name) return 1
			return 0
		})

		userList = doSort(userList, 'alpha', 'first_name')

		const teamRouteProps = {
			searchTerm,
			toggleState,
			isPremium,
			shouldBlockTransition
		}

		return (
			<div className="team-container">
				<MobileFooterButtons buttons={buttonProps} />
				<header className="main-header">
					<h1>
						People
					</h1>
					<div className="button-area" />
					<MainHeaderNav 
						right={false} 
						relUrl={match.url} 
						navtabs={navtabs} 
						type='routes' 
						relUrl={match.url}
					/>
				</header>
				<main>
					<SectionControls 
						buttons={buttonProps} 
						toggleState={toggleState} 
						toggleChangeCallback={this.toggleView} 
						searchTerm={searchTerm} 
						onSearchTermChange={this.onSearchTermChange} 
						toggleOptions={(tabName !== 'teams' && tabName !== 'stakeholders') ? this.toggleOptions : null} 
					/>
					<Switch>
						<Route path={match.url+"/staff"} key='1' render={routeProps => (
							<TeamRoute 
								{...routeProps} 
								{...teamRouteProps}
								userList={userList}
								inviteList={inviteList}
								type={'people'}
								amAdmin={amAdmin}
								path={match.path}
							/>
						)} />
						<Route 
							path={match.url+"/guests"} 
							render={routeProps => (
								<TeamRoute 
									{...routeProps} 
									{...teamRouteProps}
									userList={userList}
									inviteList={inviteList}
									type={'guests'}
									amAdmin={amAdmin}
									path={match.path}
								/>
							)} 
						/>
						<Route 
							path={match.url+"/teams"} 
							render={routeProps => (
								<TeamRoute 
									{...routeProps} 
									{...teamRouteProps}
									type={'team'}
									teamList={teamList}
									canEditTeam={canEditTeam}
									deleteTeam={this.deleteTeam}
									editTeam={this.editTeam}
									path={match.path}
								/>
							)} 
						/>
						<Route
							path={match.url+'/stakeholders'}
							render={routeProps => (
								<TeamRoute 
									{...routeProps} 
									{...teamRouteProps}
									userList={userList}
									type={'stakeholders'}
									amAdmin={amAdmin}
									path={match.path}
								/>
							)}
						/>
						<Redirect to={match.path+'/staff'} />
					</Switch>
				</main>
			</div>
		);
	}
}

const mapStateToProps = state => {
  return {
		currentAccount: state.account.currentAccount,
		accountData: getCurrentAccount(state),
		userData: getCurrentUser(state),
		allUsers: state.account.entities.users,
		allInvitations: state.account.entities.invitations,
		allGuests: state.account.entities.guests,
		allTeams: state.account.entities.teams,
		allStakeholders: state.account.entities.stakeholders,
		amAdmin: isCurrentUserAdmin(state),
		roles: getUserRoles(state),
		isPremium: isPremium(state)
  }
}

export default withRouter(connect(mapStateToProps, {
	openModal, 
	changeTitle, 
	logoutUser,
	togglePreference,
	getStakeholdersAndPurposes
})(Team))